
class Pubsub {

	scope = {};

	constructor(config){

		Object.assign(this, config);
	}

	publish(event, ...args){

		this.scope.trigger(event, ...args);
	}

	subscribe(event, callback){

		this.scope.on(event, callback)
	}

	unsubscribe(event){

		this.scope.off(event);
	}

}

export {
	Pubsub
};

/*
function component(){}
function subscribe(){}
function publish(){}

@component()
class Foo {

	constructor(){
		super();
		this.sendUpdate({
			a: 123,
			b: 456
		});
	}

	@subscribe('channel1 updateURL') onUpdateUrl({ a, b }){

	}

	@publish('channel1 updateURL') sendUpdate(options){
		return options;
	}
}
*/